export enum Features {
  OE_STUDY_PLAN = 'OE_STUDY_PLAN',
}
